var _path, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.23077C5 8.51639 5.11346 8.79031 5.31542 8.99227C5.51738 9.19423 5.79131 9.30769 6.07692 9.30769C6.36254 9.30769 6.63646 9.19423 6.83842 8.99227C7.04039 8.79031 7.15385 8.51639 7.15385 8.23077V6.07692C7.15385 5.79131 7.04039 5.51738 6.83842 5.31542C6.63646 5.11346 6.36254 5 6.07692 5C5.79131 5 5.51738 5.11346 5.31542 5.31542C5.11346 5.51738 5 5.79131 5 6.07692V8.23077ZM5 8.23077C5 11.0869 6.13461 13.8261 8.15423 15.8458C10.1739 17.8654 12.9131 19 15.7692 19H17.9231C18.2087 19 18.4826 18.8865 18.6846 18.6846C18.8865 18.4826 19 18.2087 19 17.9231C19 17.6375 18.8865 17.3635 18.6846 17.1616C18.4826 16.9596 18.2087 16.8462 17.9231 16.8462H15.7692C15.4836 16.8462 15.2097 16.9596 15.0077 17.1616C14.8058 17.3635 14.6923 17.6375 14.6923 17.9231C14.6923 18.2087 14.8058 18.4826 15.0077 18.6846C15.2097 18.8865 15.4836 19 15.7692 19",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.5,
    cy: 7,
    rx: 1.5,
    ry: 2,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 17.5,
    rx: 1.5,
    ry: 2,
    transform: "rotate(-90 17 17.5)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.0caf7e72.svg";
export { ForwardRef as ReactComponent };